import React from "react";
import { Link } from "react-router-dom";

const Logo: React.FC = () => {
  return (
    <>
      <Link to="/?anchor=speakers">
        <picture>
          <img
            src={require("@public/images/logo.svg")}
            alt="ОТМ"
            width="69"
            height="34"
            className="pointer-events-none"
          />
        </picture>
      </Link>
      {/* <div className="main-nav__logo-description">
        <p className="main-nav__logo-description-top">Intensive</p>
        <p className="main-nav__logo-description-bottom">by Profi Travel</p>
      </div> */}
    </>
  );
};

export default Logo;
